export const ANGULAR_INIT_TIMEOUT_MS = 500;
export const ANSI_ESCAPE_CODE = 27;
export const ANSI_ESCAPE_LENGTH = 3;
export const ASCII_SPACE = 32;
export const BASE_36_RADIX = 36;
export const BUN_BUILD_WARNING_SUPPRESSION =
	'wildcard sideEffects are not supported yet';
/* Tailwind v4 at-rules that Bun's native CSS parser doesn't recognize.
   When a user imports their Tailwind entry CSS from a TS/TSX file, Bun's
   bundler walks it and warns about each unknown at-rule even though the
   actual Tailwind output is produced via the separate tailwindcss compile()
   pipeline (see compileTailwind.ts). The warnings are noise — suppress them. */
export const TAILWIND_BUN_CSS_WARNING_PATTERN =
	/invalid @ rule encountered: '@(theme|tailwind|source|utility|variant|custom-variant|apply|reference|plugin|config)'/;
export const BODY_SLICE_LENGTH = 2000;
export const BYTES_PER_KILOBYTE = 1024;
export const CLI_ARGS_OFFSET = 3;
export const CSS_ERROR_RESOLVE_DELAY_MS = 50;
export const CSS_MAX_CHECK_ATTEMPTS = 10;
export const CSS_MAX_PARSE_TIMEOUT_MS = 500;
export const CSS_SHEET_READY_TIMEOUT_MS = 100;
export const DEFAULT_CHUNK_SIZE = 16_384;
export const DEFAULT_DEBOUNCE_MS = 15;
export const DEFAULT_PORT = 3000;
export const DEV_SERVER_RESTART_DEBOUNCE_MS = 100;
export const DOM_UPDATE_DELAY_MS = 50;
export const FILE_PROTOCOL_PREFIX_LENGTH = 7;
export const FOCUS_ID_PREFIX_LENGTH = 3;
export const FOCUS_IDX_PREFIX_LENGTH = 4;
export const FOCUS_NAME_PREFIX_LENGTH = 5;
export const ESLINT_STUDIO_DEFAULT_HOST = 'eslint.absolute.localhost';
export const ESLINT_STUDIO_DEFAULT_PORT = 4099;
export const CONFIG_DEFAULT_HOST = 'config.absolute.localhost';
export const CONFIG_DEFAULT_PORT = 4099;
export const HMR_UPDATE_TIMEOUT_MS = 2000;
export const HOOK_SIGNATURE_LENGTH = 12;
export const EXCLUDE_LAST_OFFSET = -1;
export const HTTP_STATUS_OK = 200;
export const HTTP_STATUS_BAD_REQUEST = 400;
export const HTTP_STATUS_NOT_FOUND = 404;
export const HOURS_IN_DAY = 24;
export const HOURS_IN_HALF_DAY = 12;
export const IMAGE_DEFAULT_DEVICE_SIZES = [
	640, 750, 828, 1080, 1200, 1920, 2048, 3840
];
export const IMAGE_DEFAULT_IMAGE_SIZES = [16, 32, 48, 64, 96, 128, 256, 384];
export const IMAGE_DEFAULT_QUALITY = 75;
export const IMAGE_GLOB_SUFFIX_LENGTH = 2;
export const INSTANCE_PROBE_TIMEOUT_MS = 250;
export const MAX_ERROR_LENGTH = 200;
export const MAX_RECONNECT_ATTEMPTS = 60;
export const MILLISECONDS_IN_A_SECOND = 1000;
export const MINUTES_IN_AN_HOUR = 60;
export const SECONDS_IN_A_MINUTE = 60;
export const MILLISECONDS_IN_A_MINUTE =
	MILLISECONDS_IN_A_SECOND * SECONDS_IN_A_MINUTE;
export const MILLISECONDS_IN_A_DAY =
	MILLISECONDS_IN_A_SECOND *
	SECONDS_IN_A_MINUTE *
	MINUTES_IN_AN_HOUR *
	HOURS_IN_DAY;
export const OVERLAY_FADE_DURATION_MS = 150;
export const PING_INTERVAL_MS = 30_000;
export const LIST_LOG_TAIL_MAX_BYTES = 65_536;
export const LIST_TUI_COLUMN_GAP = 2;
export const LIST_TUI_DEFAULT_HEIGHT = 28;
export const LIST_TUI_DEFAULT_WIDTH = 100;
export const LIST_TUI_ESCAPE_SEQUENCE_TIMEOUT_MS = 30;
export const LIST_TUI_FOOTER_LINE_COUNT = 2;
export const LIST_TUI_MARKER_WIDTH = 2;
export const LIST_TUI_MIN_LOG_HEIGHT = 3;
export const LIST_TUI_MIN_URL_WIDTH = 16;
export const LIST_TUI_RENDER_DEBOUNCE_MS = 16;
export const LIST_TUI_STATUS_MESSAGE_TIMEOUT_MS = 4000;
export const LIST_WATCH_REFRESH_MS = 1000;
export const RAF_BATCH_COUNT = 3;
export const RANDOM_ID_END_INDEX = 11;
export const REBUILD_BATCH_DELAY_MS = 10;
export const REBUILD_RELOAD_DELAY_MS = 200;
export const RECONNECT_INITIAL_DELAY_MS = 500;
export const RECONNECT_POLL_INTERVAL_MS = 300;
export const REACT_STREAM_SLOT_FAST_DELAY_MS = 5;
export const REACT_STREAM_SLOT_SLOW_DELAY_MS = 20;
export const SIGINT_EXIT_CODE = 130;
export const SIGTERM_EXIT_CODE = 143;
export const SVELTE_CSS_LOAD_TIMEOUT_MS = 500;
export const TIME_PRECISION = 2;
export const TWO_THIRDS = 2 / 3;
export const UNFOUND_INDEX = -1;
export const WEBSOCKET_NORMAL_CLOSURE = 1000;
// Default Bun WebSocket idleTimeout (seconds) applied to every absolute server.
// Long-lived sockets (voice intake, referee, realtime sync) sit idle during
// greeting playback or while a user listens silently — no client→server frames.
// Without an explicit value the WS idleTimeout falls back to Elysia's small
// top-level serve default (~30s, closing at ~60s), which kills these sessions
// mid-call with INACTIVE_CLIENT. 240s outlasts any greeting or think-pause and
// gives a briefly-suspended tab time to wake and reconnect. Paired with Bun's
// `sendPings` (protocol-level keepalive the browser answers without JS, so a
// throttled background tab still responds). Bun's hard ceiling is 960s.
export const DEFAULT_WEBSOCKET_IDLE_TIMEOUT_SECONDS = 240;
// HTTP idleTimeout for Bun.serve. Bun's DEFAULT is a hostile 10s for a
// framework meant to host streaming/AI workloads: a long-lived SSE response
// (or any long poll) that stays silent past 10s — e.g. an agentic AI turn
// waiting on the model's first token after a large tool result inflates the
// prompt — gets its socket reaped with no error, and the client hangs. 240s
// mirrors the WS default and outlasts realistic model think-pauses; Bun's
// hard ceiling for HTTP idleTimeout is 255s. Override per-app with the
// ABSOLUTE_IDLE_TIMEOUT env var (seconds; 0 disables the timeout entirely).
export const DEFAULT_HTTP_IDLE_TIMEOUT_SECONDS = 240;
export const MAX_HTTP_IDLE_TIMEOUT_SECONDS = 255;
export const WORKSPACE_COMMAND_ARGS_OFFSET = 3;
export const WORKSPACE_FAILURE_LOG_PRINT_LIMIT = 30;
export const WORKSPACE_FAILURE_RECENT_LOG_LIMIT = 60;
export const WORKSPACE_READY_ATTEMPT_TIMEOUT_MS = 5_000;
export const WORKSPACE_READY_PROBE_INTERVAL_MS = 250;
export const WORKSPACE_READY_TIMEOUT_MS = 30_000;
export const WORKSPACE_SHUTDOWN_TIMEOUT_MS = 10_000;
export const WORKSPACE_TUI_DEFAULT_HEIGHT = 28;
export const WORKSPACE_TUI_DEFAULT_WIDTH = 100;
export const WORKSPACE_TUI_ESCAPE_SEQUENCE_TIMEOUT_MS = 30;
export const WORKSPACE_TUI_FOOTER_LINE_COUNT = 3;
export const WORKSPACE_TUI_MIN_LOG_HEIGHT = 3;
export const WORKSPACE_TUI_MIN_SERVICE_NAME_WIDTH = 7;
export const WORKSPACE_TUI_MIN_TARGET_WIDTH = 8;
export const WORKSPACE_TUI_MIN_WRAP_WIDTH = 12;
export const WORKSPACE_TUI_PROMPT_CURSOR_OFFSET = 3;
export const WORKSPACE_TUI_RECENT_LOG_LIMIT = 40;
export const WORKSPACE_TUI_RENDER_DEBOUNCE_MS = 16;
export const WORKSPACE_TUI_STATUS_WIDTH = 10;
export const WORKSPACE_TUI_TARGET_PADDING_WIDTH = 6;
export const WORKSPACE_TUI_VISIBILITY_WIDTH = 8;
